import { Injectable } from "@angular/core";
import { User } from "../user.model";
import { Role } from "../enum/role.enum";
import { TerminalAdapter } from "./terminal.adapter";

@Injectable({
    providedIn: "root",
})
export class UserAdapter {

    constructor(private readonly terminalAdapter: TerminalAdapter) {}

    /**
     * Permet d'adapter les données d'une DTO à un utilisateur
     * @param item DTO
     * @returns Utilisateur
     */
    public adapt(item: any): User {
        return new User(
            item.id,
            item.lastname,
            item.firstname,
            item.email,
            this.mapStringToRole(item.role),
            item.linkedWithTerminal || false,
            item.isLoggedIn || false,
            item.createdAt,
            this.terminalAdapter.adaptMany(item.terminals || []),
            this.terminalAdapter.adaptMany(item.commercialTerminals || []),
            item.supplierNumber
        );
    }

    /**
     * Convertit une string en enum Role
     * @param roleString String du rôle
     * @returns Enum Role
     */
    private mapStringToRole(roleString: string): Role {
        switch (roleString?.toUpperCase()) {
            case 'ADMIN':
                return Role.ADMIN;
            case 'CLIENT':
                return Role.CLIENT;
            case 'COMMERCIAL':
                return Role.COMMERCIAL;
            case 'SUPER_COMMERCIAL':
                return Role.SUPER_COMMERCIAL;
            default:
                return Role.CLIENT; // Par défaut
        }
    }
}